// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_50-0";
export var eligibilityCardNotEligible = "_50-1";